import { render } from "./nuevaSolicitud.vue?vue&type=template&id=de881362&scoped=true"
import script from "./nuevaSolicitud.vue?vue&type=script&lang=js"
export * from "./nuevaSolicitud.vue?vue&type=script&lang=js"

import "./nuevaSolicitud.vue?vue&type=style&index=0&id=de881362&scoped=true&lang=css"
import "./nuevaSolicitud.vue?vue&type=style&index=1&id=de881362&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de881362"]])

export default __exports__